import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    borderRadius: pxToRem(32),
    padding: `${pxToRem(2)} ${pxToRem(15)} ${pxToRem(2)} ${pxToRem(15)}`,
    width: 'auto',
    textAlign: 'center',
    flex: '0 1 auto',
  },
  test: {
    fontSize: pxToRem(12),
    fontWeight: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    margin: `0 ${pxToRem(2)} 0 0`,
    opacity: 1,
  },
  status: {
    fontSize: pxToRem(12),
    fontWeight: '600',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    margin: `0 ${pxToRem(2)} 0 0`,
    opactiy: 1,
  },
});
